import PropTypes from 'prop-types'
import { Box, Icon } from '@redriverpress/system'
import { CONTENT_TYPES } from 'Common/constants/contentTypes'

// TODO: define the icon and bg for Lesson and Lesson packs
const CONTENT_TYPE_STYLES = {
  [CONTENT_TYPES.flashcardCategory]: {
    backgroundColor: 'yellow500',
    icon: 'bolt',
  },
  [CONTENT_TYPES.flashcardSet]: {
    backgroundColor: 'yellow500',
    icon: 'bolt',
  },
  [CONTENT_TYPES.lesson]: {
    backgroundColor: 'gray300',
    icon: 'file-alt',
  },
  [CONTENT_TYPES.course]: {
    backgroundColor: 'gray300',
    icon: 'backpack',
  },
  [CONTENT_TYPES.video]: {
    backgroundColor: 'blue300',
    icon: 'camera-movie',
  },
}

export default function CoverImageFallback({
  contentType,
  iconFontSize,
  ...props
}) {
  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='center'
      borderRadius='circular'
      bg={CONTENT_TYPE_STYLES[contentType].backgroundColor}
      {...props}
    >
      <Icon
        icon={CONTENT_TYPE_STYLES[contentType].icon}
        weight='solid'
        fontSize={iconFontSize}
      />
    </Box>
  )
}

CoverImageFallback.defaultProps = {
  iconFontSize: 1,
}

CoverImageFallback.propTypes = {
  iconFontSize: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ]),
  contentType: PropTypes.oneOf([
    CONTENT_TYPES.flashcardCategory,
    CONTENT_TYPES.flashcardSet,
    CONTENT_TYPES.lesson,
    CONTENT_TYPES.course,
    CONTENT_TYPES.video,
  ]).isRequired,
}
